import {
  BYSTADIUM_HOSTNAME,
  BYSTADIUM_PROD_HOSTNAME,
  BYSTADIUM_DASHBOARD_HOSTNAME,
  BYSTADIUM_DASHBOARD_PROD_HOSTNAME,
} from "@stadium/helpers/app-routes";

export const getOrigin = (url) => {
  try {
    if (!url) return null;
    const parsedUrl = new URL(url);
    if (parsedUrl.origin === BYSTADIUM_PROD_HOSTNAME) {
      return BYSTADIUM_HOSTNAME;
    }
    if (parsedUrl.origin === BYSTADIUM_DASHBOARD_PROD_HOSTNAME) {
      return BYSTADIUM_DASHBOARD_HOSTNAME;
    }
  } catch (e) {}
  return null;
};

export const replaceOrigin = ({ url = "", getOriginToBeReplaceWith = getOrigin }) => {
  const replacedOrigin = getOriginToBeReplaceWith(url);
  if (!replacedOrigin) {
    return url;
  }
  const parsedUrl = new URL(url, window.location.origin);
  return url.replace(parsedUrl.origin, getOriginToBeReplaceWith(url));
};

export const isValidUrl = (url) => {
  const urlPattern = /^(https?:\/\/)([\w-]+\.)+[\w-]+(\/[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=-]*)?$/;
  return urlPattern.test(url);
};
